module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iain Provan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Iain Provan is Marshall Sheppard Professor of Biblical Studies at Regent College. His other books include "), _c('I', [_vm._v("A Biblical History of")]), _c('I', [_vm._v("Israel")]), _vm._v(", The NIV Application Commentary volume on Ecclesiastes and Song of Songs, and "), _c('I', [_vm._v("Seriously Dangerous Religion: What the Old")]), _c('I', [_vm._v("Testament Really Says and Why It Matters.")]), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sDsHa1/tc-custom/9781467445412.jpg?1731883574984",
      "alt": "This image is the cover for the book Discovering Genesis, Discovering Biblical Texts (DBT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Discovering Genesis, Discovering Biblical Texts (DBT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Concise, student-friendly introduction to Genesis")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Iain Provan here offers readers a compact, up-to-date, and student-friendly introduction to the book of Genesis, focusing on its structure, content, theological concerns, key interpretive debates, and historical reception."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Drawing on a range of methodological approaches (author-, text-, and reader-centered) as complementary rather than mutually exclusive ways of understanding, "), _c('i', [_vm._v("Discovering Genesis")]), _vm._v(" encourages students to dig deeply into the theological and historical questions raised by the text. It provides a critical assessment of key interpreters and interpretive debates, focusing especially on the reception history of the biblical text, a subject of growing interest to students and scholars of the Bible."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Society for Promoting Christian Knowledge\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0